var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('Modal', {
    attrs: {
      "title": "替换成功"
    },
    on: {
      "on-ok": _vm.confirm,
      "on-cancel": _vm.confirm
    },
    model: {
      value: _vm.replceSuccessModel,
      callback: function ($$v) {
        _vm.replceSuccessModel = $$v;
      },
      expression: "replceSuccessModel"
    }
  }, [_c('p', [_vm._v("本次搜查到" + _vm._s(_vm.serachCount) + "个配方材料")]), _c('p', [_vm._v("成功替换" + _vm._s(_vm.successReplaceCount) + "个配方材料")])]), _c('div', {
    staticClass: "input-wrap"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('FormItem', {
    attrs: {
      "label": "搜索原材料",
      "prop": "serachMaterial"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.getRecipeMethod
    },
    model: {
      value: _vm.formItem.serachMaterial,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "serachMaterial", $$v);
      },
      expression: "formItem.serachMaterial"
    }
  }, _vm._l(_vm.filteredMaterialList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.model ? item.model : item.name))]);
  }), 1)], 1)], 1), _c('div', {
    staticClass: "replace-wrap"
  }, [_c('FormItem', {
    attrs: {
      "label": "替换原材料",
      "prop": "replaceMaterial"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "disabled": _vm.formItem.serachMaterial ? false : true,
      "loading": _vm.replaceMaterialLoading
    },
    on: {
      "on-change": _vm.getRecipeMethod
    },
    model: {
      value: _vm.formItem.replaceMaterial,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "replaceMaterial", $$v);
      },
      expression: "formItem.replaceMaterial"
    }
  }, _vm._l(_vm.materialList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.model ? item.model : item.name))]);
  }), 1)], 1)], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _c('div', {
    staticClass: "recipe-wrap"
  }, [_c('div', {
    staticClass: "recipe-list"
  }, _vm._l(_vm.searchRecipeList, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "recipe-item"
    }, [_c('Card', {
      staticStyle: {
        "width": "320px"
      }
    }, [_c('div', {
      staticClass: "recipe-info"
    }, [_c('div', {
      staticClass: "card-title"
    }, [_c('h3', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.customer.name))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("配方")]), _c('div', [_vm._v("#" + _vm._s(item.NoId) + " " + _vm._s(item.name))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("创建人")]), _c('div', [_vm._v(_vm._s(item.createdBy.name))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("审核人")]), _c('div', [_vm._v(_vm._s(item.verifiedBy ? item.verifiedBy.name : ""))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("状态")]), _c('div', [_vm._v(_vm._s(_vm.cardStatusToText(item.status)))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("创建时间")]), _c('div', [_vm._v(_vm._s(_vm.formatDate(item.createdAt)))])])]), _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("材料")]), _c('div', {
      staticClass: "table-title"
    }, [_vm._v("比例")])]), _vm._l(item.detail, function (x) {
      return _c('div', {}, [_c('MaterialRow', {
        attrs: {
          "detail": x,
          "serachMaterial": _vm.formItem.serachMaterial
        }
      })], 1);
    })], 2)], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }